module.exports = __webpack_public_path__ + "media/images/application/template/arrow-left-58e974c1f2dc34f0fd265de53b776843.png";